import React from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';

import { IconProps, SvgIcon } from './SvgIcon';

interface StoreStatusIconProps extends IconProps {
  status?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  closed: {
    color: theme.palette.error.main,
  },
  open: {
    color: theme.palette.success.main,
  },
}));

export function StoreStatus(props: StoreStatusIconProps): JSX.Element {
  const { status, ...rest } = props;

  const classes = useStyles();
  const statusStyles = clsx(
    status === 'closed' && classes.closed,
    status === 'open' && classes.open,
  );

  return (
    <SvgIcon name="StoreStatus" {...rest} className={statusStyles}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0C5.372 0 0 5.373 0 12s5.372 12 12 12c6.627 0 12-5.373 12-12S18.627 0 12 0z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
